module.exports = __webpack_public_path__ + "static/media/bball-icon-white.3909e92d.svg";